import React from "react";
import ArchitectureDiagram from "../../../../assets/images/trueCloud/architecture-diagram.svg";

const FeatureListItem = ({ label, bordered = true }) => (
  <div
    className={`flex items-center gap-2 bg-[#f9fbff] rounded-[10px] px-1.5 h-8 ${
      bordered ? "border border-[rgba(1,110,252,0.01)]" : ""
    }`}
  >
    <span className="w-6 h-6 flex items-center justify-center shrink-0">
      <span className="w-1.5 h-1.5 rounded-full bg-[#2350bf]" />
    </span>
    <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal">
      {label}
    </p>
  </div>
);

const subscriptionFeatures = [
  "User Interface And Data",
  "SMPT Services",
  "Unlimited User Roles",
  "Push notifications",
  "Temporary Log In's",
  "Mobile Credential Issuance",
  "Scheduled Updates And Notifications Web RTC",
  "Mobile Web page",
  "Stored Backups",
];

const keyBenefits = [
  "Unlimited Doors And Sites",
  "Secure Video Management",
  "Automated Services",
];

export const CloudSubscriptionSection = () => {
  return (
    <section className="bg-white px-6 lg:px-[120px] py-[60px]">
      <div className="max-w-[1260px] mx-auto flex flex-col items-center gap-[3px]">
        <div className="w-full flex flex-col gap-8">
          <h2 className="text-[#2350bf] text-[32px] font-semibold font-['Inter'] text-center leading-[46px] max-w-[456px] mx-auto">
            True Cloud Subscription Features & Benefits
          </h2>

          <div className="flex flex-col lg:flex-row gap-8 w-full">
            <div className="bg-[rgba(234,240,255,0.25)] border border-[#bfd1ff] rounded-2xl p-6 flex flex-col gap-10 min-h-[568px] w-full lg:w-[614px] lg:shrink-0">
              <h3 className="text-[#2350bf] text-2xl font-medium font-['Inter']">
                Features
              </h3>
              <div className="flex flex-col gap-[15px] w-full max-w-[515px]">
                {subscriptionFeatures.map((feature) => (
                  <FeatureListItem key={feature} label={feature} bordered />
                ))}
              </div>
            </div>

            <div className="bg-[rgba(234,240,255,0.25)] rounded-2xl p-6 flex flex-col gap-10 min-h-[568px] w-full lg:w-[614px] lg:shrink-0">
              <h3 className="text-[#2350bf] text-2xl font-medium font-['Inter']">
                Key Benefits
              </h3>
              <div className="flex flex-col gap-[15px] w-full max-w-[515px]">
                {keyBenefits.map((benefit) => (
                  <FeatureListItem
                    key={benefit}
                    label={benefit}
                    bordered={false}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="w-full overflow-x-auto pt-[3px]">
          <img
            src={ArchitectureDiagram}
            alt="True Cloud system architecture diagram"
            className="w-full min-w-[700px] max-w-[1061px] h-auto object-contain mx-auto"
          />
        </div>
      </div>
    </section>
  );
};
